import React, { Component, Fragment } from 'react'

import {
    Button,
    Input,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    CircularProgress
} from '@material-ui/core'

class ForgotPassword extends Component {
    constructor(props) {
        super(props)

        this.state = {
            success: false
        }
    }

    success = (bool) => {
        this.setState({
            success: bool
        })
    }

    successRender = () => (
        <Fragment>
            <DialogTitle id="form-dialog-title">Success</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    The new password has been sent to your email
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={() => {
                        this.success(false)
                        this.props.handleClose()
                    }}
                    color="primary"
                >
                    Close
                </Button>
            </DialogActions>
        </Fragment>
    )

    default = () => (
        <Fragment>
            <DialogTitle id="form-dialog-title">Forgot your password?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Type your email and we will send you a new password
                    </DialogContentText>
                    <Input
                        autoFocus
                        id="name"
                        label="Email Address"
                        type="email"
                        fullWidth
                        value={this.props.email}
                        onChange={this.props.onChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={() => this.props.resetPassword(this.props.email, () => this.success(true))} color="primary">
                        Submit
                    </Button>
                </DialogActions>
        </Fragment>
    )

    loading = () => (
        <DialogContent>
            <CircularProgress size={30} />
        </DialogContent>
    )

    render = () => (
        <Dialog
            open={this.props.open}
            onClose={() => {
                this.succes(false)
                this.props.handleClose()
            }}
            aria-labelledby="form-dialog-title"
        >
            {this.state.success
                ? this.successRender()
                : this.props.loading
                    ? this.loading()
                    : this.default()
            }
        </Dialog>
    )

}

export default ForgotPassword